// import AdminRoutes from '../../Features/Admin/Pages/Routes';
// import ClientRoutes from '../../Features/Client/Pages/Routes';
// import AuthenticationRoutes from '../../Features/Authentication/Routes';
// const PrivateRoute = [...AuthenticationRoutes];

import Dashboard from '../../Features/Patient/Dashboard/pages/Dashboard';
import AdminRoutes from '../../Features/Admin/Routes';
import Report from '../../Features/Patient/Reports/pages/Report';
import UserProfile from '../../Features/Patient/Profile/pages/UserProfile';
import MyOrder from '../../Features/Patient/MyOrder/MyOrder';
import TassoOrders from '../../Features/Patient/TassoOrders/TassoOrders';
import Coach from '../../Features/Patient/Coach/Coach';
import CryoStorage from '../../Features/Patient/CryoStorage/CryoStorage';
// import Support from '../../Features/Patient/Support/Support';
import OrderNextTest from '../../Features/Patient/OrderNextTest/OrderNextTest';
import AddSpouse from '../../Features/Patient/AddSpouse/AddSpouse';
import ScheduleConsultation from '../../Features/Patient/ScheduleConsultation/ScheduleConsultation';
import ReferFriend from '../../Features/Patient/ReferFriend/ReferFriend';
import TestHistory from '../../Features/Patient/TestHistory/TestHistory';
import Advice from '../../Features/Patient/Advice/Advice';
import AccountInfo from '../../Features/Patient/AccountInfo/AccountInfo';
import MedicationStatus from '../../Features/Patient/Medication/MedicationStatus';
import MedicationPage from '../../Features/Patient/Medication/MedicationPage';
import SupplementInfo from '../../Features/Patient/Medication/SupplementInfo';
import PaymentPage from '../../Features/Patient/Payment/PaymentPage';
import PaymentSuccess from '../../Features/Patient/Payment/PaymentSuccess';
import PharmacyStatus from '../../Features/Patient/PharmacyStatus/PharmacyStatus';

const PrivateRoutes = [
  ...AdminRoutes,
  {
    path: '/dashboard',
    element: <Dashboard />,
    allowedRoles: ['user'],
  },
  {
    path: '/report',
    element: <Report />,
    allowedRoles: ['user', 'admin'],
  },
  {
    path: '/user-profile',
    element: <UserProfile />,
    allowedRoles: ['user', 'admin'],
  },
  {
    path: '/orders',
    element: <MyOrder />,
    allowedRoles: ['user', 'admin'],
  },
  {
    path: '/tasso-orders',
    element: <TassoOrders />,
    allowedRoles: ['user', 'admin'],
  },
  {
    path: '/coach',
    element: <Coach />,
    allowedRoles: ['user'],
  },
  {
    path: '/cryo-storage',
    element: <CryoStorage />,
    allowedRoles: ['user'],
  },
  // {
  //   path: '/support',
  //   element: <Support />,
  //   allowedRoles: ['user'],
  // },
  {
    path: '/order-next-test',
    element: <OrderNextTest />,
    allowedRoles: ['user'],
  },
  {
    path: '/add-spouse',
    element: <AddSpouse />,
    allowedRoles: ['user'],
  },
  {
    path: '/schedule-consultation',
    element: <ScheduleConsultation />,
    allowedRoles: ['user'],
  },
  {
    path: '/refer-a-friend',
    element: <ReferFriend />,
    allowedRoles: ['user'],
  },
  {
    path: '/test-history',
    element: <TestHistory />,
    allowedRoles: ['user'],
  },
  {
    path: '/advice',
    element: <Advice />,
    allowedRoles: ['user'],
  },
  {
    path: '/account-info',
    element: <AccountInfo />,
    allowedRoles: ['user'],
  },
  {
    path: '/medication-status',
    element: <MedicationStatus />,
    allowedRoles: ['user'],
  },
  {
    path: '/supplement-info',
    element: <SupplementInfo />,
    allowedRoles: ['user'],
  },
  {
    path: '/supplement',
    element: <MedicationPage />,
    allowedRoles: ['user'],
  },
  {
    path: '/medication',
    element: <MedicationPage />,
    allowedRoles: ['user'],
  },
  {
    path: '/payment',
    element: <PaymentPage />,
    allowedRoles: ['user'],
  },
  {
    path: '/payment-success',
    element: <PaymentSuccess />,
    allowedRoles: ['user'],
  },
  {
    path: '/pharmacy-status',
    element: <PharmacyStatus />,
    allowedRoles: ['user'],
  },
];

export default PrivateRoutes;
